import React, { useState } from 'react';
import styles from '../../styles/Accordion.module.scss';
import Caret from './Caret';

export default function Accordion({ title, defaultOpen = true, children }) {
  const [open, setOpen] = useState(!!defaultOpen);
  return (
    <section className={`${styles.acc} ${open ? styles.open : ''}`}>
      <button
        type="button"
        className={styles.head}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span>{title}</span>
        <span className={styles.caret} aria-hidden>
          <Caret up={false} />
        </span>
      </button>
      {open && <div className={styles.body}>{children}</div>}
    </section>
  );
}
